import { MissionHistory } from '../types/missionHistory';

/**
 * Адаптер для преобразования данных игр клана в формат MissionHistory
 */
export const adaptClanGamesToMissionHistory = (
  clanGames: any[], 
  clanName: string,
  refereeNameFallback: string = 'Unknown Referee',
  clanId?: string
): MissionHistory[] => {
  return clanGames.map((clanGame) => {
    const teams = clanGame.teams || [];
    const humanTeam = teams.find((team: any) => team.faction?.toLowerCase() === 'human');
    const alienTeam = teams.find((team: any) => team.faction?.toLowerCase() === 'alien');

    // Определяем победившую команду
    const winningTeam = teams.find((team: any) => team.isWin === true);
    const teamThatWon = winningTeam?.faction || clanGame.gameResult?.teamThatWon || '';
    
    // Показываем команду победителей или первую команду если ничья
    let displayFaction = '';
    let result = 'Draw';
    let pointsEarned = 0;
    
    // Ищем очки конкретного клана в данных миссии
    if (clanId && clanGame.clan && Array.isArray(clanGame.clan)) {
      const clanData = clanGame.clan.find((c: any) => c.clanId === clanId);
      pointsEarned = clanData?.points || 0;
    }
    
    if (teamThatWon) {
      // Показываем победившую команду
      displayFaction = teamThatWon.toLowerCase();
      result = 'Victory';
      // Если очки клана не найдены, используем fallback
      if (pointsEarned === 0) {
        pointsEarned = clanGame.gameResult?.pointsEarnedForWinners || 10;
      }
    } else {
      // Ничья - показываем первую доступную команду
      displayFaction = humanTeam?.faction || alienTeam?.faction || teams[0]?.faction || 'human';
      result = 'Draw';
      // Если очки клана не найдены, используем fallback
      if (pointsEarned === 0) {
        pointsEarned = clanGame.gameResult?.pointsEarnedForLosers || Math.floor((clanGame.gameResult?.pointsEarnedForWinners || 10) / 2);
      }
    }

    return {
      id: clanGame.id || clanGame.uniqGameId || '',
      uniqGameId: clanGame.uniqGameId || '',
      operationId: clanGame.operationId || 'Unknown Operation',
      fieldId: clanGame.fieldId || '',
      fieldName: clanGame.fieldName || 'Unknown Field',
      refereeId: clanGame.refereeId || '',
      refereeName: clanGame.refereeName || refereeNameFallback,
      gameType: clanGame.gameType || 'airsoft',
      missionDate: clanGame.missionDate || new Date().toISOString(),
      playerFaction: displayFaction.toLowerCase(),
      isPlayerWinner: result === 'Victory',
      result: result,
      pointsEarned: pointsEarned,
      gameDuration: clanGame.gameResult?.gameDuration || 0,
      notes: clanGame.notes || '',
      isRanked: clanGame.isRanked !== undefined ? clanGame.isRanked : true,
      bonusPoints: 0,
      teamThatWon: clanGame.gameResult?.teamThatWon || teamThatWon
    };
  });
};